export default "__VITE_ASSET__BcLFykrd__"